import styled from 'styled-components'
import { COLORS } from 'theme'
import Flex from 'components/Flex'
import { FONT } from 'theme/font'
import { StyledTabs } from 'components/TabsPaneStyles'
import { Dropdown, Button } from 'antd'
import Input from 'components/Form/Input'

export const StyledTabFilter = styled(StyledTabs)`
  .ant-tabs-content-holder .ant-tabs-content {
    height: 300px !important;
    overflow: scroll;
    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-track {
      background: ${COLORS.PRIMARY_GREY_T_98};
    }
    &::-webkit-scrollbar-thumb {
      background: ${COLORS.PRIMARY_GREY_T_80};
      border-radius: 4px;
    }
  }
  .ant-tabs {
    width: 30% !important;
    height: 100vh;
  }
  .ant-tabs-tab {
    padding: 15px !important;
    margin: 0 !important;
  }
  .ant-tabs-nav {
    width: 190px !important;
    // height: calc(100vh - 200px);
    position: relative;
  }
  .ant-tabs-nav-wrap {
    height: 100%;
    overflow: auto !important;
    &::-webkit-scrollbar {
      width: 6px;
      display: block;
    }
    &::-webkit-scrollbar-track {
      background: ${COLORS.PRIMARY_GREY_T_98};
      border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb {
      background: ${COLORS.PRIMARY_GREY_T_80};
      border-radius: 4px;
    }
  }
  .ant-tabs-nav-list {
    width: 98%;
    height: auto;
    position: relative;
  }
  .ant-tabs-nav-operations {
    display: none !important; /* Hide the three dots menu */
  }
  .ant-tabs-tabpane.ant-tabs-tabpane-active {
    padding: 0px 24px;
  }
  .ant-tabs-content-holder {
    width: 320px;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-track {
      background: ${COLORS.PRIMARY_GREY_T_98};
    }
    &::-webkit-scrollbar-thumb {
      background: ${COLORS.PRIMARY_GREY_T_80};
      border-radius: 4px;
    }
  }
  .ant-tabs-tab .ant-tabs-tab-btn {
    width: max-content;
  }
  .degree-department {
    margin-top: 1rem;
  }
  .ant-tabs-tab.ant-tabs-tab-active {
    background: transparent;
  }
`

export const DropDown = styled(Dropdown)``
export const DropBtn = styled(Button)`
  .ant-btn {
    background: ${COLORS.PRIMARY_GREY_T_98} !important;
  }
`

export const StyledTab = styled(StyledTabs)`
  background: white;
  .ant-tabs-nav::before {
    border-bottom: none;
  }
  .ant-tabs-tab {
    border-bottom: none !important;
    padding: 15px 15px !important;
    margin-left: 0px;
  }
  .ant-tabs-nav {
    width: 100% !important;
    margin: 0 !important;
  }

  .ant-tabs-tab-btn {
    color: ${COLORS.GREY_T_50_2};
    text-shadow: 0 0 0.25px currentcolor;
  }
  .ant-tabs-ink-bar {
    height: 4px !important;
    background: ${COLORS.PRIMARY} !important;
  }
  ${
    '' /* .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${COLORS.PRIMARY};
  } */
  }
  .ant-tabs-tab {
    padding: 15px 20px !important;
    margin-top: 0 !important;
    color: ${COLORS.GREY_T_60};
    background: ${COLORS.WHITE} !important;
    border-radius: 0 !important;
  }

  width: 100%;
  .ant-tabs-content {
    height: 250px !important;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`

export const PaddedDiv = styled(Flex)`
  width: 100%;
  padding: 20px 25px;
  gap: 25px;
`
export const SectionWrapper = styled(Flex)`
  width: 100%;
  height: 100vh;
  overflow: scroll;
  background: ${COLORS.WHITE};
  &::-webkit-scrollbar {
    display: none;
  }
`
export const TopHeader = styled(Flex)`
  position: relative;
  width: 100%;
  font-size: ${FONT.F_3XL};
`
export const RoleNameFlex = styled(Flex)`
  gap: 10px;
  cursor: pointer;
`
export const TopEndFlex = styled(Flex)`
  gap: ${props => (props?.gap ? props?.gap : '0')};
`
export const LeftSection = styled(Flex)`
  gap: 20px;
`
export const SectionName = styled(Flex)`
  gap: ${props => (props.disable ? '0px' : '10px')};
`
export const RoleNameDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_XL};
  color: ${COLORS.GREY_T_20};
  margin: 10px 0 10px;
  text-transform: capitalize;
`

export const ThreeDotsDiv = styled.div`
  .ant-btn {
    background: ${COLORS.PRIMARY_GREY_T_98} !important;
    border-radius: 10px !important;
    border: 1px solid ${COLORS.GREY_T_90} !important;
    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
    width: 38px !important;
    height: 38px !important;
  }
  cursor: pointer;
  border-left: 1px solid ${COLORS.GREY_T_90};
  padding-left: 10px;
`
export const SectinFlex = styled(Flex)``

export const CardsRowFlex = styled(Flex)`
  gap: 15px;
`
export const CardSectionFlex = styled(Flex)`
  gap: 15px;
  cursor: pointer;
`
export const CardsDiv = styled.div`
  border-right: 1px solid ${COLORS.GREY_T_90};
  padding-right: 15px;
  cursor: pointer;
`
export const CardsFlex = styled(Flex)`
  padding: 10px 15px;
  gap: 6px;
  min-width: 141px;
  min-height: 100%;
  background: ${props => (props?.isSelected ? COLORS.GREY_T_95 : COLORS.WHITE)};
  border-radius: 10px;
  border: 1px solid ${COLORS.GREY_T_90};
`
export const CardText = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_XS};
  line-height: 15px;
  color: ${COLORS.GREY_T_50_2};
  text-transform: capitalize;
`
export const CardsValue = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_SM};
  line-height: 21px;
  color: ${COLORS.GREY_T_30};
`
export const CandidatesSpan = styled.span`
  padding: 2px 6px;
  margin-left: 10px;
  width: 29px;
  height: 19px;
  background: ${COLORS.PAGE_BORDER};
  border-radius: 20px;
`
export const RoleFlex = styled(Flex)``
export const RoleNumber = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_XS};
  line-height: 15px;
  color: ${COLORS.GREY_T_60};
`
export const RoleTitle = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: 14px;
  line-height: 21px;
  color: ${COLORS.GREY_T_30};
`
export const CandCount = styled.div`
  padding: 2px 10px;
  width: 37px;
  height: 19px;
  background: ${COLORS.PRIMARY};
  border-radius: 20px;

  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_XS};
  line-height: 15px;
  color: ${COLORS.WHITE};
`
export const BulkUploadDiv = styled.div`
  margin: 0 10px;
  padding-right: 10px;
`

export const HeadText = styled(Flex)`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #676e83;
  margin-top: 10px;
`
export const SubText = styled(Flex)`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #999fac;
  margin-top: 10px;
`
export const SettingIconDiv = styled.div`
  height: 34px;
  width: 34px;
  background: #3249d7;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`
export const SettingIconClick = styled.div`
  margin-top: 2px;
  cursor: pointer;
`
export const SettingButtonDiv = styled.div`
  margin-right: 15px;
`

export const InterviewDivTop = styled.div`
  display: flex;
`
export const InterviewDivItem = styled.div`
  margin-right: 15px;
  margin-top: 10px;
`

export const Div = styled.div`
  padding-top: 20px;
`

export const IconContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  cursor: pointer;
  margin-top: 5px;
`

export const IconText = styled.h4`
  margin-bottom: 6px;
  color: rgba(128, 134, 151, 1);
  cursor: auto;
`
export const ShortList = styled.button`
  color: #3249d7;
  backgroud-color: #fbfaff;
  border: 1px solid #e3deff;
  border-radius: 8px;
  padding: 5px 15px;
  cursor: ${props => (props.disable ? 'not-allowed' : 'pointer')};
  font-weight: 600;
  opacity: ${props => (props.disable ? '0.5' : '1')};
`
export const TextEllipse = styled.div`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-weight: 600;
  color: ${props => (props.disable ? '#000' : 'rgb(227, 94, 80)')};
`
export const ConflictName = styled.div`
  color: ${props => (props.disable ? '#000' : '#E35E50')};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: inherit;
  font-weight: ${props => props.disable && '500'};
  text-transform: ${props => props.caps && 'capitalize'};
`

export const Minus = styled.div`
  display: flex;
  justify-content: center;
`
export const ConflictPara = styled.p`
  line-height: initial;
  font-weight: ${props => props.font && '600'};
`
export const ConflictFlex = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;
  border: 1px solid #eff0fc;
  border-radius: 10px;
  margin-bottom: 1rem;
  cursor: pointer;
`
export const ConflictInnerFlex = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-left: 10px;
`
export const ConflictInnerContent = styled.p`
  line-height: initial;
  font-weight: ${props => (props.disable ? '600' : '500')};
  color: ${props => (props.disable ? '#000' : '#999FAC')};
  font-size: ${props => (props.disable ? '0.95rem' : '0.8rem')};
  margin: 0px;
`
export const SelectAllFlex = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  flex-wrap: wrap;
`
export const FileError = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 4rem;
  color: red;
  font-weight: 500;
`

export const StyleInput = styled(Input)`
  &.ant-input-affix-wrapper {
    border-radius: 10px 10px 0px 0px !important;
    border-bottom: 0px;
  }
  .ant-input {
    font-weight: 400;
    font-size: 16px;
    margin-left: 10px;
  }
`
